import React, { Component } from 'react';
import '../../css/pages/agents.css';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import iconSprite from '../../assets/icon-sprite.svg';
import { createAgent } from '../actions/account';
import { getAllStates, getOptions } from '../actions/utils';

class CreateAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: 0,
      locations: {},
      borrower_category: {},
    };
  }

  componentDidMount() {
    this.props.getAllStates();
    this.props.getOptions();
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (e) => e.preventDefault();

  Navigator = () => {
    const { pos, loading } = this.state;
    const { history } = this.props;
    return (
      <div className="buttonCTA d-flex justify-content-space-between">
        <button
          type="button"
          className="btn btn-primary w-50 mx-2"
          style={{ visibility: (pos === 0 || loading) ? 'hidden' : 'visible' }}
          onClick={() => this.setState({ pos: Math.max(pos - 1, 0) })}>
          Back
        </button>
        <button
          type="button"
          className="btn btn-primary w-50 mx-2"
          hidden={pos === 4}
          onClick={() => this.setState({ pos: Math.min(pos + 1, 4) })}>
          Continue
        </button>
        <button
          type="button"
          className="btn btn-primary w-50 mx-2"
          hidden={pos !== 4}
          disabled={!!loading}
          onClick={() => {
            this.setState({ loading: 'Processing' }, async () => {
              try {
                // eslint-disable-next-line react/destructuring-assignment
                const locations = Object.keys(this.state.locations)
                  .filter((id) => !!id).map((id) => ({ state_id: `${id}` }));
                const borrower_category = Object.keys(this.state.borrower_category)
                  .filter((id) => !!id).map((id) => ({ id: `${id}` }));
                const data = { ...this.state, locations, borrower_category };
                const response = await createAgent(data);
                if (response.status !== 'success') throw new Error(response?.message);
                toast.success(response?.message, {
                  onClose: () => {
                    history.push('/agents');
                  },
                });
              } catch (error) {
                this.setState({ loading: false },
                  () => toast.error(error.response?.data?.message || error.response?.statusText
                    || error.message
                    || 'Seems like something went wrong with your request. Please try again.'));
              }
            });
          }}>
          {loading || 'Submit'}
        </button>
      </div>
    );
  }

  render() {
    const { pos, locations, borrower_category } = this.state;
    const { business, states, options } = this.props;
    const borrower_categories = options.find((x) => x.key === 'borrower-category')?.options || [];

    return (
      <>
        <SideNav />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav />
            <section className="body-main__content">
              <div className="pageTitle pageTitle--main">
                <a href="agents.html" className="btn-with-navig d-inline-flex justify-content-center align-items-center d-lg-none">
                  <div className="icon">
                    <svg width="20" height="20">
                      <use xlinkHref={`${iconSprite}#go-back`}></use>
                    </svg>
                  </div>
                  <p>Back to Agents</p>
                </a>
              </div>
              <main className="create-agent__main">
                <div className="create-agent__main--container" hidden={pos !== 0}>
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Create an agent.
                    </h3>
                    <p className="create-agent__text--subheader">
                      Enter the details of the agent.
                    </p>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Basic info</p>
                    </div>
                    <form action="" onSubmit={this.handleSubmit}>
                      <div>
                        <div className="form-group">
                          <label htmlFor="phone_number" className="form-label">Phone Number</label>
                          <input
                            type="number"
                            className="form-control"
                            name="phone_number"
                            id="phone_number"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>Phone Number is required.</p>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="email" className="form-label">Email Address</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>Email Address is required.</p>
                          </div>
                        </div>
                      </div>
                      <this.Navigator />
                    </form>
                  </div>
                </div>
                <div className="create-agent__main--container" hidden={pos !== 1}>
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Risk appetite.
                    </h3>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Enter details to set a risk appetite</p>
                    </div>
                    <form action="" onSubmit={this.handleSubmit}>
                      <div>
                        <div className="form-group">
                          <label htmlFor="min_amount" className="form-label">Minimum individual loan amount (₦)</label>
                          <input
                            type="number"
                            className="form-control"
                            id="min_amount"
                            name="min_amount"
                            onChange={this.handleOnChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="max_amount" className="form-label">Maximum individual loan amount (₦)</label>
                          <input
                            type="number"
                            className="form-control"
                            id="max_amount"
                            name="max_amount"
                            onChange={this.handleOnChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="max_loan_count" className="form-label">Maximum number of active loans</label>
                          <input
                            type="number"
                            className="form-control"
                            id="max_loan_count"
                            name="max_loan_count"
                            onChange={this.handleOnChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="max_loan_amount" className="form-label">Maximum cumulative loan amount</label>
                          <input
                            type="number"
                            className="form-control"
                            id="max_loan_amount"
                            name="max_loan_amount"
                            onChange={this.handleOnChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="minimium_credit_score" className="form-label">Minimum credit score for borrowers</label>
                          <input
                            type="number"
                            className="form-control"
                            id="minimium_credit_score"
                            name="minimium_credit_score"
                            onChange={this.handleOnChange} />
                        </div>
                      </div>
                      <this.Navigator />
                    </form>
                  </div>
                </div>
                <div className="create-agent__main--container" hidden={pos !== 2}>
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Tenor range.
                    </h3>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Enter details to set agent’s tenor range.</p>
                    </div>
                    <form action="" className="tenor-form" onSubmit={this.handleSubmit}>
                      <div className="tenor-form-section">
                        <div className="formGroup">
                          <div className="form-group">
                            <label htmlFor="min_tenor_value" className="form-label">Minimum Loan Tenor</label>
                            <input
                              type="number"
                              className="form-control"
                              id="min_tenor_value"
                              name="min_tenor_value"
                              onChange={this.handleOnChange} />
                            <div className="form-text error-message">
                              <p>Minimum Amount is required.</p>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="input-with-icon">
                              <select
                                className="form-control"
                                id="min_tenor_type"
                                name="min_tenor_type"
                                onChange={this.handleOnChange}>
                                <option disabled selected>Tenor type</option>
                                <option value="Days">Days</option>
                                <option value="Months">Months</option>
                              </select>
                              <span className="input-icon">
                                <svg width="24" height="24">
                                  <use xlinkHref={`${iconSprite}#dropdown`}></use>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="formGroup">
                          <div className="form-group">
                            <label htmlFor="max_tenor_value" className="form-label">Maximum Tenor</label>
                            <input
                              type="number"
                              className="form-control"
                              id="max_tenor_value"
                              name="max_tenor_value"
                              onChange={this.handleOnChange} />
                            <div className="form-text error-message">
                              <p>Minimum Amount is required.</p>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="input-with-icon">
                              <select
                                className="form-control"
                                id="max_tenor_type"
                                name="max_tenor_type"
                                onChange={this.handleOnChange}>
                                <option disabled selected>Tenor type</option>
                                <option value="Days">Days</option>
                                <option value="Months">Months</option>
                              </select>
                              <span className="input-icon">
                                <svg width="24" height="24">
                                  <use xlinkHref={`${iconSprite}#dropdown`}></use>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <this.Navigator />
                    </form>
                  </div>
                </div>
                <div className="create-agent__main--container" hidden={pos !== 3}>
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Borrower Preference.
                    </h3>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Enter details to set borrower preference.</p>
                    </div>
                    <form action="" className="borrower-form" onSubmit={this.handleSubmit}>
                      <div>
                        <div className="form-group">
                          <label htmlFor="risk" className="form-label">What location do you want your agent&apos;s borrowers to come from?</label>
                          <div className="checker card-checker my-3">
                            <label className="check-ticker">
                              <div className="card-check__value">
                                <input
                                type="checkbox"
                                className="check-ticker-input"
                                onChange={(e) => this.setState({
                                  locations: states.reduce((acc, cat) => {
                                    acc[cat.id] = e.target.checked;
                                    return acc;
                                  }, {}),
                                })} />
                                <span className="check-ticker__tick"></span>
                                <span>All States</span>
                              </div>
                            </label>
                          </div>
                          <div className="checker card-checker flex-wrap">
                            {states.map((o) => (
                              <label key={o.id} className="check-ticker flex-wrap w-auto p-1">
                                <div className="card-check__value">
                                  <input
                                    type="checkbox"
                                    className="check-ticker-input"
                                    checked={!!locations[o.id]}
                                    onChange={() => this.setState({
                                      locations: { ...locations, [o.id]: !locations[o.id] },
                                    })} />
                                  <span className="check-ticker__tick mx-2"></span>
                                  <span>{o.code_description}</span>
                                </div>
                              </label>
                            ))}
                          </div>
                        </div>

                        <div className="selection-cards">
                          <div className="inputTitle">
                            <p>Categories of borrowers</p>
                          </div>
                          {borrower_categories.map((o) => (
                            <div className="form-group" key={o.id}>
                              <div className="checker card-checker">
                                <label className="check-ticker">
                                  <div className="card-check__value">
                                    <input
                                      type="checkbox"
                                      className="check-ticker-input"
                                      checked={!!borrower_category[o.id]}
                                      onChange={() => this.setState({
                                        borrower_category: {
                                          ...borrower_category, [o.id]: !borrower_category[o.id],
                                        },
                                      })} />
                                    <span className="check-ticker__tick"></span>
                                    <span>{o.code_description}</span>
                                  </div>
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <this.Navigator />
                    </form>
                  </div>
                </div>
                <div className="create-agent__main--container" hidden={pos !== 4}>
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Agent’s preference.
                    </h3>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Enter details to set agent’s preference.</p>
                    </div>
                    <form action="" className="tenor-form" onSubmit={this.handleSubmit}>
                      <div className="">
                        <div className="form-group">
                          <label htmlFor="display_name" className="form-label">Enter display name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="display_name"
                            name="display_name"
                            defaultValue={business.name}
                            onChange={this.handleOnChange} />
                        </div>
                      </div>
                      <this.Navigator />
                    </form>
                  </div>
                </div>
              </main>
            </section>
          </div>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  states: state.utils?.states || [],
  options: state.utils?.options || [],
});

const mapDispatchToProps = {
  getAllStates,
  getOptions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateAgent);
